export default {
	"name": "Kameleoon",
	"stage": "produktion",
	"mandanten": ["2"],
	"pagetypes": "all",
	"excludedPagetypes": ["login", "bestelluebersicht"],
	"serviceSettings": {
		// Kameleoon wird bereits im Head geladen
		"SITE_CODE": "vqkseaalcr"
	}
}
